var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Stack } from '@mui/system';
import { Divider, LinearProgress, Typography } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import OpenStreetMaps from '../map/OpenStreetMaps';
import axios from 'axios';
import { useSnackbar } from 'notistack';
const currentYear = new Date().getFullYear();
export default function AddFieldWithCompanyDialog(_a) {
    var props = __rest(_a, []);
    const { enqueueSnackbar } = useSnackbar();
    const map = React.useRef(null);
    const [company, setCompany] = React.useState(null);
    const [companies, setCompanies] = React.useState([]);
    const [companyInput, setCompanyInput] = React.useState('');
    const [name, setName] = React.useState('');
    const [search, setSearch] = React.useState('');
    const [progress, setProgress] = React.useState(false);
    const [selectedElement, setSelectedElement] = React.useState(0);
    const [center, setCenter] = React.useState({ lat: 49.9714, lng: 82.6059 });
    const [json, setJson] = React.useState(null);
    // Шаг 2 регистрации (ТЗ 2.1): культура + сорт + сезон — теперь отдельный
    // запрос /field/season/create после создания самого поля.
    const [cultures, setCultures] = React.useState([]);
    const [selectedCulture, setSelectedCulture] = React.useState(null);
    const [cultureInput, setCultureInput] = React.useState('');
    const [grades, setGrades] = React.useState([]);
    const [selectedGrade, setSelectedGrade] = React.useState(null);
    const [gradeInput, setGradeInput] = React.useState('');
    const [season, setSeason] = React.useState(currentYear);
    const getGradeCultureId = (g) => { var _a, _b, _c; return (_c = (_b = (_a = g.grade_culture) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : g.grade_culture_id) !== null && _c !== void 0 ? _c : g.culture_id; };
    const availableGrades = React.useMemo(() => grades.filter((g) => getGradeCultureId(g) === (selectedCulture === null || selectedCulture === void 0 ? void 0 : selectedCulture.id)), [grades, selectedCulture]);
    // Обязательны: контур, название, культура, сезон. Сорт — опционален.
    const access = !json || name.length === 0 || cultureInput.trim().length === 0 || !season;
    React.useEffect(() => {
        if (props.token) {
            get_companies();
        }
    }, []);
    React.useEffect(() => {
        if (company !== null) {
            setCenter({ lat: company.latitude, lng: company.longitude });
            if (name == '') {
                let fullname = company.name.split(',')[0];
                setName(fullname);
            }
        }
    }, [company]);
    React.useEffect(() => {
        if (map.current) {
            map.current.setFly(center, 13);
        }
    }, [center]);
    React.useEffect(() => {
        if (search.length > 3) {
            get_companies(search == '' ? undefined : search);
        }
        if (search == '') {
            get_companies();
        }
    }, [search]);
    React.useEffect(() => {
        if (!props.open || !props.token)
            return;
        axios.get("/culture/list?limit=100&offset=0", {
            headers: { Authorization: `Bearer ${props.token}` }
        }).then(res => {
            var _a, _b, _c;
            console.log("cultures response:", (_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b[0]);
            if ((_c = res.data) === null || _c === void 0 ? void 0 : _c.items)
                setCultures(res.data.items);
        });
        axios.get("/grade/list?limit=100&offset=0", {
            headers: { Authorization: `Bearer ${props.token}` }
        }).then(res => {
            var _a, _b, _c;
            console.log("grades response:", (_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b[0]);
            if ((_c = res.data) === null || _c === void 0 ? void 0 : _c.items)
                setGrades(res.data.items);
        }).catch((err) => {
            console.log("grades error:", err);
            setGrades([]);
        });
    }, [props.open, props.token]);
    // Смена культуры сбрасывает выбранный сорт, если он к ней не относится
    React.useEffect(() => {
        if (selectedGrade && getGradeCultureId(selectedGrade) !== (selectedCulture === null || selectedCulture === void 0 ? void 0 : selectedCulture.id)) {
            setSelectedGrade(null);
            setGradeInput('');
        }
    }, [selectedCulture]);
    React.useEffect(() => {
        if (company !== null) {
            setCenter({ lat: company.latitude, lng: company.longitude });
            if (name === '') {
                setName(company.name.split(',')[0]);
            }
        }
        else if (companyInput.trim() !== '' && name === '') {
            setName(companyInput.trim());
        }
    }, [company, companyInput]);
    const get_companies = (search) => {
        axios.get(`/field/company/list?limit=100${search ? '&name__like=' + search : ''}`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${props.token}`
            }
        })
            .then((response) => {
            if (response.data) {
                setCompanies(response.data.items.map((x) => {
                    x.label = x.name;
                    return x;
                }));
            }
        });
    };
    const normalizeName = (value) => value.trim().replace(/\s+/g, ' ');
    const ensureCulture = () => __awaiter(this, void 0, void 0, function* () {
        var _b, _c;
        const cultureName = normalizeName(cultureInput);
        if (!cultureName)
            throw new Error('Укажите культуру');
        const existing = cultures.find((item) => normalizeName(item.cultures_name).toLocaleLowerCase() === cultureName.toLocaleLowerCase());
        if (existing)
            return existing;
        const response = yield axios.post('/culture/create', {
            cultures_name: cultureName,
            cultures_code: null,
        }, {
            headers: { Authorization: `Bearer ${props.token}` }
        });
        const id = Number((_b = response.data) === null || _b === void 0 ? void 0 : _b.id);
        if (!((_c = response.data) === null || _c === void 0 ? void 0 : _c.success) || !Number.isInteger(id) || id <= 0) {
            throw new Error('Не удалось создать культуру');
        }
        const created = { id, cultures_name: cultureName, cultures_code: null };
        setCultures((items) => [...items, created]);
        return created;
    });
    const ensureGrade = (culture) => __awaiter(this, void 0, void 0, function* () {
        var _d, _e;
        const gradeName = normalizeName(gradeInput);
        if (!gradeName)
            return null;
        const existing = grades.find((item) => getGradeCultureId(item) === culture.id &&
            normalizeName(item.grade_name).toLocaleLowerCase() === gradeName.toLocaleLowerCase());
        if (existing)
            return existing;
        const response = yield axios.post('/grade/create', {
            id: 0,
            grade_name: gradeName,
            grade_code: null,
            grade_culture_id: culture.id,
            grade_nitrogen: null,
            grade_phosphorus: null,
            grade_potassium: null,
            grade_k: null,
        }, {
            headers: { Authorization: `Bearer ${props.token}` }
        });
        const id = Number((_d = response.data) === null || _d === void 0 ? void 0 : _d.id);
        if (!((_e = response.data) === null || _e === void 0 ? void 0 : _e.success) || !Number.isInteger(id) || id <= 0) {
            throw new Error('Не удалось создать сорт');
        }
        const created = {
            id,
            grade_name: gradeName,
            grade_code: null,
            grade_culture: culture,
            grade_nitrogen: null,
            grade_phosphorus: null,
            grade_potassium: null,
            grade_k: null,
        };
        setGrades((items) => [...items, created]);
        return created;
    });
    const create = () => __awaiter(this, void 0, void 0, function* () {
        var _f, _g, _h;
        if (json === null || name === '' || cultureInput.trim() === '')
            return;
        try {
            json.id = 0;
            let geo = {
                type: "FeatureCollection",
                features: [json]
            };
            let build = JSON.parse(JSON.stringify(geo));
            if (build.features.length > 0) {
                let coords = build.features[0].geometry.coordinates.map((c) => [c[1], c[0]]);
                const firstPoint = coords[0];
                const lastPoint = coords[coords.length - 1];
                if (coords.length > 0 && (firstPoint[0] !== lastPoint[0] || firstPoint[1] !== lastPoint[1])) {
                    coords.push([...firstPoint]);
                }
                build.features[0].geometry.coordinates = [coords];
            }
            const formData = new FormData();
            formData.append("name", name);
            formData.append("geo", JSON.stringify(build));
            setProgress(true);
            // Шаг 1: только геометрия и название
            const fieldResponse = yield axios.post("/field/create_with_map", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "Authorization": `Bearer ${props.token}`
                }
            });
            if (!fieldResponse.data.success || !fieldResponse.data.field_id) {
                const error = fieldResponse.data.error || 'Не удалось создать поле';
                enqueueSnackbar(error.length > 100 ? `${error.substring(0, 97)}...` : error, { variant: 'error' });
                setProgress(false);
                return;
            }
            const fieldId = fieldResponse.data.field_id;
            // Шаг 2: культура + сорт + сезон
            try {
                const culture = yield ensureCulture();
                const grade = yield ensureGrade(culture);
                yield axios.post("/field/season/create", {
                    field_id: fieldId,
                    season: season,
                    culture_id: culture.id,
                    grade_id: (_f = grade === null || grade === void 0 ? void 0 : grade.id) !== null && _f !== void 0 ? _f : null,
                }, {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${props.token}`
                    }
                });
                enqueueSnackbar('Поле успешно добавлено', { variant: 'success', autoHideDuration: 1500 });
            }
            catch (seasonError) {
                // Поле уже создано — не откатываем, просто предупреждаем.
                // Сезон можно будет добавить позже со страницы поля.
                enqueueSnackbar('Поле создано, но не удалось сохранить сезон — добавьте его отдельно на странице поля', { variant: 'warning', autoHideDuration: 4000 });
            }
            destroy();
            if (props.update !== undefined)
                props.update();
            props.setState(false);
        }
        catch (e) {
            const errorMessage = ((_h = (_g = e === null || e === void 0 ? void 0 : e.response) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.detail) || (e === null || e === void 0 ? void 0 : e.message) || String(e);
            enqueueSnackbar(errorMessage.length > 100 ? `${errorMessage.substring(0, 97)}...` : errorMessage, { variant: 'error' });
            setProgress(false);
        }
    });
    const destroy = () => __awaiter(this, void 0, void 0, function* () {
        setName('');
        setProgress(false);
        setSelectedCulture(null);
        setCultureInput('');
        setSelectedGrade(null);
        setSeason(currentYear);
        setSelectedGrade(null);
        setGradeInput('');
        setCompany(null);
        setCompanyInput('');
    });
    return (React.createElement("div", null,
        React.createElement(Dialog, { maxWidth: 'md', open: props.open, BackdropProps: { style: { backdropFilter: "blur(3px)" } } },
            React.createElement(DialogTitle, null, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043F\u043E\u043B\u0435"),
            React.createElement(DialogContent, null,
                React.createElement(Box, { sx: { padding: '16px' } },
                    React.createElement(Typography, { color: "text.secondary", variant: "body2" }, "\u0417\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435 \u043F\u043E\u043B\u044F \u0434\u043B\u044F \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u044F \u043D\u043E\u0432\u043E\u0433\u043E \u043F\u043E\u043B\u044F \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0435")),
                React.createElement(Divider, { variant: "middle" }),
                React.createElement(Stack, { spacing: 2, direction: 'column', sx: { padding: '0px 16px', marginTop: '16px' } },
                    React.createElement(Autocomplete, { freeSolo: true, value: company, inputValue: companyInput, onChange: (e, newValue) => {
                            var _a;
                            if (typeof newValue === 'string') {
                                setCompany(null);
                                setCompanyInput(newValue);
                                return;
                            }
                            setCompany(newValue);
                            setCompanyInput((_a = newValue === null || newValue === void 0 ? void 0 : newValue.name) !== null && _a !== void 0 ? _a : '');
                        }, onInputChange: (event, newInputValue) => {
                            setCompanyInput(newInputValue);
                            setSearch(newInputValue);
                        }, disablePortal: true, options: companies, sx: { width: 'auto' }, getOptionLabel: (option) => typeof option === 'string' ? option : option.name, isOptionEqualToValue: (option, value) => typeof value !== 'string' && option.id === value.id, renderInput: (params) => (React.createElement(TextField, Object.assign({}, params, { label: "\u041F\u0440\u0435\u0434\u043F\u0440\u0438\u044F\u0442\u0438\u0435", placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0438\u043B\u0438 \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043F\u0440\u0435\u0434\u043F\u0440\u0438\u044F\u0442\u0438\u0435" }))) }),
                    React.createElement(TextField, { margin: "dense", label: "\u041D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435", fullWidth: true, variant: "filled", inputProps: { maxLength: props.maxLength }, value: name, onChange: (e) => setName(e.target.value) }),
                    React.createElement(Stack, { direction: "row", spacing: 2 },
                        React.createElement(Autocomplete, { sx: { flex: 2 }, freeSolo: true, options: cultures, getOptionLabel: (option) => typeof option === 'string' ? option : option.cultures_name, value: selectedCulture, inputValue: cultureInput, onChange: (_, newValue) => {
                                var _a;
                                if (typeof newValue === 'string') {
                                    setSelectedCulture(null);
                                    setCultureInput(newValue);
                                    return;
                                }
                                setSelectedCulture(newValue);
                                setCultureInput((_a = newValue === null || newValue === void 0 ? void 0 : newValue.cultures_name) !== null && _a !== void 0 ? _a : '');
                            }, onInputChange: (_, newValue) => {
                                setCultureInput(newValue);
                                if (selectedCulture && normalizeName(newValue) !== normalizeName(selectedCulture.cultures_name)) {
                                    setSelectedCulture(null);
                                }
                            }, renderInput: (params) => (React.createElement(TextField, Object.assign({}, params, { variant: "filled", label: "\u041A\u0443\u043B\u044C\u0442\u0443\u0440\u0430", placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0438\u043B\u0438 \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u043E\u0432\u0443\u044E \u043A\u0443\u043B\u044C\u0442\u0443\u0440\u0443", required: true }))) }),
                        React.createElement(Autocomplete, { sx: { flex: 2 }, freeSolo: true, options: availableGrades, getOptionLabel: (option) => typeof option === 'string' ? option : option.grade_name, value: selectedGrade, inputValue: gradeInput, disabled: cultureInput.trim().length === 0, onChange: (_, newValue) => {
                                var _a;
                                if (typeof newValue === 'string') {
                                    setSelectedGrade(null);
                                    setGradeInput(newValue);
                                    return;
                                }
                                setSelectedGrade(newValue);
                                setGradeInput((_a = newValue === null || newValue === void 0 ? void 0 : newValue.grade_name) !== null && _a !== void 0 ? _a : '');
                            }, onInputChange: (_, newValue) => {
                                setGradeInput(newValue);
                                if (selectedGrade && normalizeName(newValue) !== normalizeName(selectedGrade.grade_name)) {
                                    setSelectedGrade(null);
                                }
                            }, renderInput: (params) => (React.createElement(TextField, Object.assign({}, params, { variant: "filled", label: "\u0421\u043E\u0440\u0442", placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0438\u043B\u0438 \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u043E\u0432\u044B\u0439 \u0441\u043E\u0440\u0442" }))) }),
                        React.createElement(TextField, { sx: { flex: 1 }, margin: "dense", label: "\u0421\u0435\u0437\u043E\u043D", type: "number", variant: "filled", value: season, onChange: (e) => setSeason(parseInt(e.target.value) || currentYear) })),
                    React.createElement(Box, { component: "span", sx: { p: 0, border: '1px dashed grey', display: 'flex', width: '700px', height: '480px' } },
                        React.createElement(OpenStreetMaps, { ref: map, token: props.token, url: null, center: center, editMode: {
                                polygon: true,
                                circlemarker: false,
                                remove: true
                            }, setJson: setJson, item: selectedElement })),
                    progress == true && (React.createElement(LinearProgress, null)))),
            React.createElement(DialogActions, null,
                React.createElement(Button, { disabled: access || progress, onClick: () => create() }, "\u0421\u043E\u0437\u0434\u0430\u0442\u044C"),
                React.createElement(Button, { disabled: progress, onClick: () => {
                        destroy();
                        props.setState(false);
                    } }, "\u041E\u0442\u043C\u0435\u043D\u0430")))));
}
